import ticketLine from "../../assets/TicketLine/TicketLineTwo.png";
import artmart from "../../assets/Artmart/ArtmartOne.png";
import randomMath from "../../assets/RandomMath/RandomMathTwo.png";
import familyTree from "../../assets/FamilyTree/FamilyTreeThree.png";
import verbund from "../../assets/VerbundVisionMobile/VerbundVisionMobileFour.png";
import { SiAngular, SiSpring, SiPostgresql, SiVuedotjs } from "react-icons/si";
import { FaDocker, FaJava } from "react-icons/fa";
import { DiNodejsSmall } from "react-icons/di";
import { FiDatabase, FiLink } from "react-icons/fi";

export const projects = [
  {
    id: "ticket-line",
    title: "Ticket Line",
    category: "Full-stack web application",
    description: "An event ticketing platform for discovering events, reserving tickets, and making purchases. Built with an Angular frontend, a Spring backend, and PostgreSQL.",
    image: ticketLine,
    imageAlt: "Ticket Line event search and booking interface",
    technologies: [{ label: "Angular", Icon: SiAngular }, { label: "Spring", Icon: SiSpring }, { label: "PostgreSQL", Icon: SiPostgresql }],
    href: "https://github.com/ukalto/Ticket-Line",
    linkLabel: "View source code",
    source: true,
  },
  {
    id: "artmart",
    title: "Artmart",
    category: "Frontend · E-commerce",
    description: "An online art store built around the Metropolitan Museum of Art collection API. Browse artwork and explore a shopping experience built with Vue.",
    image: artmart,
    imageAlt: "Artmart gallery displaying artworks from the Metropolitan Museum of Art collection",
    technologies: [{ label: "Vue", Icon: SiVuedotjs }, { label: "Museum API", Icon: FiLink }],
    href: "https://github.com/ukalto/Web-Engineering",
    linkLabel: "View source code",
    source: true,
  },
  {
    id: "random-math",
    title: "RandomMath",
    category: "Full-stack · Learning",
    description: "A web app for practicing calculations, tracking progress, and competing with other math enthusiasts. Combining a playful learning experience with a full-stack foundation.",
    image: randomMath,
    imageAlt: "RandomMath calculation practice application",
    technologies: [{ label: "Angular", Icon: SiAngular }, { label: "Node.js", Icon: DiNodejsSmall }, { label: "Docker", Icon: FaDocker }, { label: "SQL", Icon: FiDatabase }],
    href: "https://github.com/ukalto/RandomMath",
    linkLabel: "View source code",
    source: true,
  },
  {
    id: "family-tree",
    title: "FamilyTree",
    category: "Full-stack · Data management",
    description: "A tool for managing horses, their owners, and their pedigrees. It brings related records together to make ancestry and family relationships easier to trace.",
    image: familyTree,
    imageAlt: "FamilyTree horse and pedigree management application",
    technologies: [{ label: "Angular", Icon: SiAngular }, { label: "Spring", Icon: SiSpring }, { label: "PostgreSQL", Icon: SiPostgresql }],
    href: "https://github.com/ukalto/Family-Tree",
    linkLabel: "View source code",
    source: true,
  },
  {
    id: "verbund-vision",
    title: "Verbund Vision Mobile",
    category: "Android · Diploma project",
    description: "An Android application developed for my diploma project in partnership with Verbund AG, taking inspiration from the official Verbund Vision app.",
    image: verbund,
    imageAlt: "Verbund Vision Mobile running on an Android phone",
    technologies: [{ label: "Java", Icon: FaJava }, { label: "API integration", Icon: FiLink }],
    href: "https://www.verbund.com/de-at/geschaeftskunden/online-services",
    linkLabel: "Verbund online services",
    source: false,
  },
];
